import React, { useState } from "react";
import { Zap, Twitter, Github, Linkedin, Mail } from "../../utils/icons";
import Button from "../ui/Button";

const links = {
  Product: ["Features", "Pricing", "Changelog", "Roadmap"],
  Company: ["About", "Blog", "Careers", "Press"],
  Resources: ["Documentation", "API Reference", "Status", "Community"],
  Legal: ["Privacy", "Terms", "Cookie Policy", "GDPR"],
};

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail("");
    }
  };

  return (
    <footer className="bg-gray-50 dark:bg-gray-900/50 border-t border-gray-200 dark:border-gray-800">
      <div className="max-container section-pad">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 mb-16">
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <div className="flex items-center gap-2 font-display font-bold text-xl mb-3">
              <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg flex items-center justify-center">
                <Zap size={16} className="text-white" />
              </div>
              <span className="gradient-text">NexaFlow</span>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-5 max-w-xs leading-relaxed">
              The modern SaaS platform that helps teams move faster, collaborate
              better, and grow smarter.
            </p>
            <div className="flex gap-3">
              {[Twitter, Github, Linkedin, Mail].map((IconComp, i) => (
                <a
                  key={i}
                  href="#"
                  className="p-2 rounded-xl border border-gray-200 dark:border-gray-700 text-gray-500 hover:text-primary-600 hover:border-primary-400 transition-all duration-200"
                >
                  <IconComp size={16} />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(links).map(([group, items]) => (
            <div key={group}>
              <h4 className="font-semibold font-display text-sm text-gray-900 dark:text-white mb-4">
                {group}
              </h4>
              <ul className="space-y-2.5">
                {items.map((item) => (
                  <li key={item}>
                    <a
                      href="#"
                      className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-primary-600 to-violet-600 rounded-2xl p-8 mb-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-display text-xl font-bold text-white mb-1">
              Stay in the loop
            </h3>
            <p className="text-primary-200 text-sm">
              Get product updates, tips, and launch news.
            </p>
          </div>
          {subscribed ? (
            <div className="flex items-center gap-2 bg-white/20 text-white px-5 py-3 rounded-xl font-medium text-sm">
              ✓ You're subscribed!
            </div>
          ) : (
            <form
              onSubmit={handleSubscribe}
              className="flex w-full md:w-auto gap-2"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                className="flex-1 md:w-64 px-4 py-3 rounded-xl bg-white/20 border border-white/30 text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 text-sm"
              />
              <Button
                variant="subtle"
                type="submit"
                className="!bg-white !text-primary-700 hover:!bg-primary-50 whitespace-nowrap"
              >
                Subscribe
              </Button>
            </form>
          )}
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-gray-400">
          <p>
            © {new Date().getFullYear()} NexaFlow, Inc. All rights reserved.
          </p>
          <p>Made with ♥ for modern teams</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
